import MasterProductList from './MasterProductList.vue';

export const productRoutes = [
  { path: 'product', component: MasterProductList, name: 'product' }
];
